import { Express } from "express";
import { readFileSync, writeFileSync } from "fs";
import dirTree from "directory-tree";
import { getSymbolFromFile, parse } from "./lib/parser";
import { getProject } from "./utils/project";
import { join } from "path";

export default function register(app: Express) {
  app.post("/api/file/getContent", (req, res) => {
    res.status(200).json({
      content: readFileSync(req.body.path, "utf-8"),
    });
  });

  app.get("/api/files", (req, res) => {
    const project = getProject();
    const files = dirTree(project.rootDirectory, {
      extensions: /\.(ts|js|jsx|tsx)$/,
      exclude: [/node_modules/, /.git/],
    });
    res.status(200).json({ files });
  });

  app.post("/api/file/getFileSymbols", (req, res) => {
    const symbol = parse(req.body.path);
    res.status(200).json({
      symbol,
    });
  });

  app.get("/api/docs", (req, res) => {
    const project = getProject();
    const docs = dirTree(project.docsDirectory, {
      extensions: /\.json/,
    });

    res.status(200).json({ docs: docs });
  });

  app.post("/api/docs/create", async (req, res) => {
    writeFileSync(join(req.body.path, req.body.name), "{}");
    res.status(200).json({});
  });

  app.post("/api/doc/save", async (req, res) => {
    writeFileSync(req.body.path, JSON.stringify(req.body.content), "utf-8");
    res.status(200).json({});
  });

  app.post("/api/doc", async (req, res) => {
    const content = readFileSync(req.body.path, "utf-8");
    res.status(200).json(JSON.parse(content));
  });

  app.post("/api/file/getFilesSymbols", async (req, res) => {
    const items: { path: string; name: string }[] = req.body.items;
    const symbols = items.map((i) => getSymbolFromFile(i.path, i.name));
    res.status(200).json(symbols);
  });
}
